import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnChanges, inject } from '@angular/core';

import { EventModel, EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { TrackingSource } from '@frontend/sports/tracking/feature';

import { OptionGroupDetail, ViewType } from '../showcase.model';

@Component({
    selector: 'ms-showcase-option-group',
    templateUrl: 'showcase-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowcaseOptionGroupComponent implements OnChanges {
    viewTypeEnum = ViewType;
    @Input() event: EventModel;
    @Input() model: OptionGroupDetail;
    @Input() tracking: TrackingSource;
    @Input() viewType: ViewType;

    optionGroup: EventOptionGroup;
    optionTracking: string;

    @HostBinding('class') className = 'option-group';

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }

    epcotEnabled = inject(EpcotConfig).isEnabled;

    constructor(private sitecore: Sitecore) {}

    ngOnChanges(): void {
        this.optionGroup = this.model.optionGroup!;
        this.optionTracking = [this.tracking, 'showcase_trackingsource']
            .filter((segment) => segment)
            .join('/')
            .toLowerCase();
    }

    getResultName = (option: EventOption, index: number): string | undefined => {
        if (this.optionGroup.categoryAttribute) {
            const first = this.optionGroup.options.indexOf(option) === 0;
            const prefix = first ? this.sitecore.eventGrid.SixPack_TotalsOver : this.sitecore.eventGrid.SixPack_TotalsUnder;

            return `${prefix} ${this.optionGroup.categoryAttribute}`;
        } else {
            return this.viewType === ViewType.SixPack ? option.optionAttribute : option.overridenName || this.optionName(index);
        }
    };

    private optionName = (index: number): string => {
        return this.model.optionNames[index] || '';
    };
}
